import { BrowserRouter } from "react-router-dom";

import AppRouter from "./router/router";

import "leaflet/dist/leaflet.css";
import "./assets/css/App.css";

function App() {
	return (
		<div className="App">
			<BrowserRouter>
				<AppRouter />
			</BrowserRouter>
		</div>
	);
}

export default App;
